import { useMemo } from 'react';
import { GymUser } from '../react/types/gym';
import { useAngularService } from './get_angular_service';

interface UseGymUsersProps {
  trainers?: boolean;
}

const useGymUsers = ({ trainers }: UseGymUsersProps = {}): GymUser[] => {
  const $rootScope = useAngularService('$rootScope');
  const users = useMemo(() => {
    const items = $rootScope.gym.users.asJson
      ? $rootScope.gym.users.asJson()
      : $rootScope.gym.users.map((item) => ({
          ...item,
          name: item.name || `${item.first_name} ${item.last_name}`,
        }));

    return trainers ? items.filter((item: GymUser) => item.trainer) : items;
  }, [$rootScope.gym.users, trainers]);

  return users;
};

export default useGymUsers;
